module.exports = __webpack_public_path__ + "img/1w.1d5ca38a.svg";